export default __webpack_public_path__ + "static/media/Scope-4.0bde0137.png";